import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";
import { AxDropdown, AxFormValidation, AxModal } from "@axess/limestone";
import { I18nHelper, Translations } from "../../Lib/Helper/I18nHelper";
import Swal from "sweetalert2";
import { AxLoading } from "../../Limestone/AxLoading/AxLoading";
import { PersonDataForm } from "./Components/PersonDataForm";
import * as models from "../Rental/RiderDetails/RiderDetailsModelBundle";
import { RequestHelper } from "../../Lib/Helper/RequestHelper";
import { AxLimeStone } from "../../Limestone/AxLimeStone";
import { ProductTriple } from "../../Models/Products/ProductTriple";
import { PriceHelper } from "../../Lib/Helper/PriceHelper";
import * as Popper from '@popperjs/core';

@ModuleName("LessonPackage.Personalization")
export class Personalization implements AxInit {
    initData: IPersonalizationInitData;
    persDropdowns: AxDropdown;
    currentPersonData: models.RiderData;
    personModal: AxModal;

    constructor(private _axLoading = new AxLoading(),
        private _i18NHelper = new I18nHelper(),
        private _axLimestone = new AxLimeStone(),
        private _priceHelper = new PriceHelper(null, false),
        private _requestHelper = new RequestHelper()) {
    }

    AxInit(init: IPersonalizationInitData): void {
        this.initData = init;

        const persDropdowns = new AxDropdown();

        this.initPackageList();

        this.personModal = new AxModal();
        this.personModal.init({
            selector: `[data-target="family_edit_modal_0"]`
        });

        persDropdowns.init(`[data-display-lp-pers="selection"]`,
            {
                searchBar: false,
                multiSelect: false,
                onSelect: (p, e) => {
                    const $parent = $(p.parent());

                    this.getPersonForm($parent, e as string);
                }
            }
        );
        this.persDropdowns = persDropdowns;

        $('[data-parent="#lessonPackage_pers_list"]').on('show.bs.collapse',
            (e) => {
                let $parent = $(e.currentTarget);
                let $packageBlock = $($parent.attr('data-parent'));
                let currentPersonValue = persDropdowns.getValue($($parent.find(`[data-display-lp-pers="selection"]`)));

                let $header = $($packageBlock.find(`[data-target="#${$parent.attr('id')}"]`));

                $(e.delegateTarget).find(`[data-display-lp-pers="form"]`).html(``);
                this.currentPersonData = null;

                if (currentPersonValue != null) {
                    this.getPersonForm($parent, currentPersonValue as string);
                    $header.find('[data-display-lp-pers="name"]').addClass('d-none');
                    $header.find('[data-display-lp-pers="rule"]').removeClass('d-none');

                }
            });

        $('[data-parent="#lessonPackage_pers_list"]').on('hidden.bs.collapse',
            (e) => {
                $(e.delegateTarget).find(`[data-display-lp-pers="form"]`).html(``);
                this.currentPersonData = null;
            });

        $(`[data-parent="#lessonPackage_pers_list"]`).on('click', '[data-display-lp-pers="apply"]',
            (e) => {
                if (!($("#personDataForm")?.valid() ?? false)) return;

                const $blockTrigger = $(`.lessonPackage_pers_list__head button[aria-expanded="true"]`);
                $blockTrigger.find('[data-display-lp-pers="name"] span').html($($blockTrigger.attr('data-target')).find('[data-display-lp-pers="selection"] .ax-dropdown__selection').html())
                $blockTrigger.find('[data-display-lp-pers="rule"]').addClass('d-none');
                $blockTrigger.find('[data-display-lp-pers="name"]').removeClass('d-none');

                AxessViewer.loadPartialView("/LessonPackage/SavePersonData",
                    this.currentPersonData,
                    (resp) => {
                        //const $blockTrigger = $(`.lessonPackage_pers_list__head button[aria-expanded="true"]`);
                        let newCount = parseInt($blockTrigger.attr('data-count')) + 1;
                        $blockTrigger.addClass('done');
                        const $nextBlockTrigger = $(`.lessonPackage_pers_list__head button[data-count="${newCount}"]`);

                        if ($nextBlockTrigger.length > 0) {
                            const $nextTargetBlock = $($nextBlockTrigger.data('target'));
                            $nextTargetBlock.collapse('show');
                        } else {
                            const $activeTargetBlock = $($blockTrigger.data('target'));
                            $activeTargetBlock.collapse('hide');
                        }

                        $(e.delegateTarget).find(`[data-display-lp-pers="form"]`).html(``);
                        this.currentPersonData = null;

                        this.validateInput();
                    });
            });

        $(`[data-display-lp-summary="submit"]`).on('click',
            (x) => {
                this._axLimestone.LockButton(x.delegateTarget);

                AxessViewer.loadPartialView('/LessonPackage/AddToCart',
                    { model: this.initData.packages },
                    result => {
                        this._axLimestone.UnlockButton(x.delegateTarget);
                        if (!result.success) {
                            this._axLoading.HideLoadingIndicator($('.compPack_bookingOptions_body')[0]);

                            Swal.fire({
                                title: this._i18NHelper.GetTranslation(Translations.Error),
                                icon: 'warning',
                                html: result.errorMsg
                            });
                        } else {
                            window.location.href = this.initData.shoppingCartUrl;
                        }
                    });
            });

        $('#family_edit_modal_0').on('submit', '#updateFamilyMember-form', (e) => {
            e.preventDefault();
            this.addPerson(e);
        })
    }

    updatePrice() {
        let price = 0;
        for (let pack of this.initData.packages) {
            const pPrice = this.initData.positionPrices.find(x => x.triple.id === pack.packageId &&
                x.triple.productGroupIdentifier === pack.tariffSheetId &&
                x.triple.projNr === pack.projNr)

            for (let pos of pPrice.positions) {
                if (pack.rentalOrderPlaceHolder?.find(x => x.packagePositionNr === pos.packagePosNo) == null) {
                    price += pos.price;
                }
            }
        }
        $('[data-display-lp-summary="price"').html(this._priceHelper.GetPriceStringWithDecimalDivisorCalced(price).toString());
    }

    validateInput() {
        if (this.initData.packages.filter(x => x.accountId === -1).length === 0) {
            $(`[data-display-lp-summary="submit"]`).prop('disabled', '');
        } else {
            $(`[data-display-lp-summary="submit"]`).prop('disabled', 'disabled');
        }
    }

    addPerson(e: JQuery.SubmitEvent) {
        AxessViewer.onSubmit(e,
            e.currentTarget,
            '/ProfileSettings/AddFamilyMember',
            (resp) => {
                if (resp.members == null) return;

                let newestMember = resp.members.sort((a, b) => b.CustomerAccountNo - a.CustomerAccountNo)[0];

                for (let dropdownE of this.persDropdowns.getElements()) {
                    //@ts-ignore
                    const instance = dropdownE._tippy as Instance<Props>;
                    const popperE: Popper.Instance = instance.popper;
                    const template = $($(popperE).find('.ax-dropdown__item')[0]).clone();
                    template.attr('data-value', newestMember.CustomerAccountNo);
                    template.find('[data-display-lp-pers="famName"]')
                        .html(`${newestMember.FirstName} ${newestMember.LastName}`);

                    // a new family member has no attributes yet: not eligible for a package with attribute restriction
                    const ownerRestricted = $(dropdownE).attr('data-owner-restricted') === 'true';

                    if (ownerRestricted) {
                        template.attr('disabled', 'disabled');

                        const hasLock = template.find('[data-display-lp-pers="lock"]').length > 0;

                        if (!hasLock) {
                            const $lock = $('<i>', { class: 'las la-lock', 'data-display-lp-pers': 'lock' });
                            const $text = template.find('.text-left');

                            $text.addClass('d-flex ax-gap-1');
                            $text.prepend($lock);
                        }
                    }
                    $(popperE).find('.ax-dropdown__menu .ax-dropdown__item[data-value]').not('[data-toggle]').last().after(template);

                    if ($(dropdownE).closest('.accordion-collapse').hasClass('show')) {
                        $(template).trigger('click');
                    }
                }
                this.personModal.close($("#family_edit_modal_0")[0]);
            },
            { lockButtonSelector: '#updateFamilyMember-form button' },
            { returnList: true });
    }

    getPersonForm($parent: JQuery<HTMLElement>, value: string, riderData?: models.RiderData) {
        const packNr = $parent.data('package');
        const tariffSheetNr = $parent.data('tariffsheet');
        const index = $parent.data('index');
        const lessonNr = $parent.data('lessonnr');

        let cartEntry = this.getPackageEntry(lessonNr, tariffSheetNr, packNr, index);
        cartEntry.accountId = parseInt(value);

        $parent.find(`[data-display-lp-pers="form"]`).html('');

        if (cartEntry.accountId == -1) {
            return;
        }

        //@ts-ignore
        riderData = riderData ?? {
            customerAccountId: cartEntry.accountId,
            unitSystem: 0,
            shoeSizeSystem: 30
        };

        AxessViewer.loadPartialView('/LessonPackage/_PersonForm',
            {
                package: {
                    id: cartEntry.packageId,
                    productGroupIdentifier: cartEntry.tariffSheetId,
                    projNr: cartEntry.projNr
                },
                lesson: cartEntry.lessonOrderValues[0],
                riderData: riderData
            },
            result => {
                const div = document.createElement('div');
                div.innerHTML = result.returnView.trim();

                const $div = $(div);
                $div.find('.ax-portlet').removeClass('ax-portlet ax-portlet--md');
                $div.find('.ax-portlet__body').removeClass('ax-portlet__body');

                $parent.find(`[data-display-lp-pers="form"]`).html(div);

                this.currentPersonData = result.customerRentalData;
                const personDataForm = new PersonDataForm(result.unitSystem);
                personDataForm.initInputsAsync(this.currentPersonData).then((x) => {
                    $parent.find('[data-display-lp-pers="apply"]').prop('disabled', $("#personDataForm")?.valid() ?? true ? null : "disabled");

                    let inputs = $parent.find(".ax-form-control");
                    for (let input of inputs) {
                        if (input.id.length === 0) continue;

                        $(input).trigger('mouseleave');
                        $(input).on('change',
                            () => {
                                $parent.find('[data-display-lp-pers="apply"]').prop('disabled',
                                    $("#personDataForm")?.valid() ?? true ? null : "disabled");
                            });
                    }
                });
                personDataForm.getReloadSubject().subscribe((data) => {
                    this.getPersonForm($parent, value, data);
                });
            });
    }


    initPackageList() {
        for (let elem of $(`[data-parent="#lessonPackage_pers_list"]`)) {
            this.optionalItemCheck(elem);

            $(elem).on('click', '[data-lp-pers="rentalitem"]', (e) => {
                this.optionalItemCheck(e.delegateTarget, e.currentTarget);
            });
        }
        this.updatePrice();
    }

    optionalItemCheck(elem: HTMLElement, checkbox?: HTMLElement) {
        const $elem = $(elem);

        const packageNr = parseInt($elem.data('package'));
        const tariffSheet = parseInt($elem.data('tariffsheet'));
        const index = parseInt($elem.data('index'));
        const lessonNr = parseInt($elem.data('lessonnr'));

        const packageEntry = this.getPackageEntry(lessonNr, tariffSheet, packageNr, index);
        packageEntry.rentalOrderPlaceHolder = packageEntry.rentalOrderPlaceHolder ?? [];

        const itemList = checkbox != null ? [checkbox] : $elem.find(`[data-lp-pers="rentalitem"]`);

        for (let box of itemList) {
            const checked = $(box).prop('checked');
            const packagePosNr = parseInt($(box).data('packagepos'));
            this.toggleOptionalItems(packageEntry, packagePosNr, checked);
        }

        this.updatePrice();
    }

    toggleOptionalItems(packageEntry, packagePosNr: number, toggle: boolean) {
        if (!toggle) {
            const tmpRentalItem =
                packageEntry.additionalRentalOrderValues.find(x => x.packagePositionNr === packagePosNr);

            if (typeof tmpRentalItem != 'undefined') {
                packageEntry.rentalOrderPlaceHolder.push(tmpRentalItem);
            }
            packageEntry.additionalRentalOrderValues =
                packageEntry.additionalRentalOrderValues.filter(x => x.packagePositionNr !== packagePosNr);
        } else {
            const tmpRentalItem =
                packageEntry.rentalOrderPlaceHolder.find(x => x.packagePositionNr === packagePosNr);

            if (typeof tmpRentalItem != 'undefined') {
                packageEntry.additionalRentalOrderValues.push(tmpRentalItem);
            }

            packageEntry.rentalOrderPlaceHolder =
                packageEntry.rentalOrderPlaceHolder.filter(x => x.packagePositionNr !== packagePosNr);
        }
    }


    getPackageEntry(lessonNr: number, tariffSheetNr: number, packageNr: number, index: number) {
        return this.initData.packages.filter(x => x.tariffSheetId === tariffSheetNr &&
            x.packageId === packageNr && typeof x.lessonOrderValues.find(y => y.lessonNr === lessonNr) != 'undefined')[index];
    }
}

interface IPersonalizationInitData {
    packages: {
        accountId: number;
        additionalRentalOrderValues: IRentalOrder[];
        rentalOrderValues: IRentalOrder[];
        rentalOrderPlaceHolder: IRentalOrder[];
        packageId: number;
        projNr: number;
        soapDateEnd: string;
        soapDateStart: string;
        tariffSheetId: number;
        lessonOrderValues: {
            lessonArcNr: number;
            lessonDefNr: number;
            lessonNr: number;
            lessonWebNr: number;
            packagePositionNr: number;
        }[];
        ticketOrderValues: {
            packagePositionNr: number;
            hasTimeSlots: boolean;
            poolNr: number;
            projNr: number;
            ticketTypeNr: number;
            timeSlotKeys: [];
        }[];
    }[];
    positionPrices: {
        triple: ProductTriple,
        positions: {
            price: number,
            packagePosNo: number
        }[]
    }[],
    shoppingCartUrl: string;
    signedIn: boolean;
    loginUrl: string;
}

interface IRentalOrder {
    rentalItemNr: number;
    rentalPersTypeNr: number;
    packagePositionNr: number;
}